<template>
  <div class="cbg-white-container input-container theme--light v-card p-16 border-card">
    <CRow>
      <CCol sm="12">
        <CRow>
          <CCol sm="6" md="3">
            <div class="common-search position-relative">
              <CInput label="Search by Name" v-model="searchMedicine" placeholder="Name" />
              <div
                v-if="searchMedicine !== ''"
                class="cross-svg center-cross-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </CCol>
          <CCol sm="6" md="3">
            <CSelect
              label="Per page"
              @update:value="udpateRecordPerPage"
              :options="perPageOptions"
            />
          </CCol>
          <CCol sm="6" md="3">
            <CSelect
              label="Filter by status"
              @update:value="udpateStatus"
              :options="statusOptions"
            />
          </CCol>
        </CRow>
      </CCol>
      <CCol xs="12" lg="12">
        <CCard>
          <CCardHeader>Medicines master</CCardHeader>
          <CCardBody>
            <div>
              <v-btn
                class="btn btn-primary mb-6"
                @click="showModal(null)"
                v-if="
                  permissions.includes('CAN_ADD_PHARMACY_MEDICINES_TEST_MASTER')
                "
              >Add medicine</v-btn>
            </div>
            <masterAddModal ref="masterAddModal" @refreshList="getMedicines()"></masterAddModal>
            <masterViewModal ref="masterViewModal" @refreshList="getMedicines()"></masterViewModal>
            <div class="table-div mb-ov-auto">
              <table class="table userlistTable small-table-width">
                <thead>
                  <tr class="table-success">
                    <th>Medicine</th>
                    <th>Cost</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="masterMedicine in masterMedicines" :key="masterMedicine.id">
                    <td class="m-width-box">{{ masterMedicine.detailed_string }}</td>
                    <td>{{ masterMedicine.cost }}</td>
                    <td>
                      {{
                      masterMedicine.is_verified ? "Verified" : "Not verified"
                      }}
                    </td>
                    <td>
                      <v-btn
                        class="btn btn-primary ml-1"
                        @click="viewMedicine(masterMedicine)"
                        v-if="
                          permissions.includes(
                            'CAN_VIEW_PHARMACY_MEDICINES_TEST_MASTER'
                          )
                        "
                      >View</v-btn>
                      <v-btn
                        class="btn btn-primary ml-1"
                        @click="showModal(masterMedicine)"
                        v-if="
                          permissions.includes(
                            'CAN_EDIT_PHARMACY_MEDICINES_TEST_MASTER'
                          )
                        "
                      >Edit</v-btn>
                      <v-btn
                        class="btn btn-danger ml-1"
                        @click="confirm(masterMedicine)"
                        v-if="
                          permissions.includes(
                            'CAN_DELETE_PHARMACY_MEDICINES_TEST_MASTER'
                          )
                        "
                      >Delete</v-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
              <pagination
                class="pagination-block"
                :recordPerPage="recordPerPage"
                :currentPage="currentPage"
                :total="total"
                @changePage="changePage"
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import { mapGetters } from "vuex";
const masterAddModal = () => import("./Add");
const masterViewModal = () => import("./View");
import debounce from "lodash/debounce";
import Swal from "sweetalert2";
export default {
  watch: {
    search: function(val) {
      this.getSearchResult();
    }
  },
  data() {
    return {
      masterMedicines: [],
      currentPage: 1,
      totalPage: 1,
      perPageOptions: [10, 20, 30, 50, 100],
      statusOptions: [
        { value: "All", label: "All" },
        { value: "1", label: "Verified" },
        { value: "0", label: "Not verified" }
      ],
      recordPerPage: 10,
      status: "ALL",
      search: null,
      searchMedicine: "",
      total: 0
    };
  },
  components: {
    masterAddModal,
    masterViewModal,
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination")
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  methods: {
    getSearchResult: debounce(function(e) {
      this.masterMedicines = [];
      this.currentPage = 1;
      this.getMedicines();
    }, 800),
    clearSearch() {
      this.searchMedicine = "";
    },
    getMedicines() {
      let url = `${config.PHARMACY_URL}api/v1/admin/master-stock`;
      let params = {
        stock_type: "medicine",
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        status: this.status,
        search: this.search
      };
      this.$http.get(url, { params: params }).then(res => {
        let response = res.body;
        this.masterMedicines = response.data;
        this.totalPage = response.last_page;
        this.total = response.total;
      });
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getMedicines();
    },
    showModal(data) {
      this.$refs.masterAddModal.showModal(data);
    },
    viewMedicine(data) {
      this.$refs.masterViewModal.showModal(data);
    },
    udpateRecordPerPage(perPage) {
      this.recordPerPage = perPage;
      this.getSearchResult();
    },
    udpateStatus(status) {
      this.status = status;
      this.getSearchResult();
    },
    confirm(masterStock) {
      Swal.fire({
        title: "Are you sure",
        text: `You want to delete ${masterStock.name} medicine?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteMasterStock(masterStock);
        }
      });
    },
    deleteMasterStock(masterStock) {
      let url = `${config.PHARMACY_URL}api/v1/admin/master-stock/${masterStock.id}`;
      this.$http.delete(url).then(res => {
        Swal.fire(res.body.message);
        this.getMedicines();
      });
    }
  },
  created() {
    this.getMedicines();
  }
};
</script>